import { withPromoNotificationsProps } from 'viewModel/orderConfirmation/promoNotifications/withPromoNotificationsProps';

import PromoNotifications from 'components/OrderConfirmation/PromoNotifications/PromoNotifications';

export default withPromoNotificationsProps(PromoNotifications);
